interface Task {
  slug: string
  name: string
  description_short: string
  description: string
  tags: string[]
  recipient_type_slugs: string[]
  iconoir_logo: string
}

interface RecipientType {
  slug: string
  name: string
  description_short: string
  description: string
  tags: string[]
  recipients: Recipient[]
}

interface Recipient {
  slug: string
  name: string
  description_short: string
  description: string
  tags: string[]
  params: any
}

interface Param {
  slug: string
  name: string
  required: boolean
  description_short: string
  description: string
  html_type: string
  placeholder: string
}

interface DynamicTask {
  recipient_name: string
  phone_number: string
  task_description: string
  metadata: string
  task: string
  task_short: string
  task_properties: any
  task_parameters: any
}

export class TaskService {
  task: any

  constructor(task: Task) {
    this.task = task
  }

  getTask(): Task {
    return this.task
  }
}

export class RecipientService {
  recipient: any

  constructor(recipient: Recipient) {
    this.recipient = recipient
  }

  getRecipient(): Recipient {
    return this.recipient
  }

  getParams(): Param[] {
    return this.recipient?.params
  }
}

export class TaskRepo {
  private client: any
  private allTasks: Array<Task> = []
  private tasks: { [key: string]: any } = {}
  private recipientTypes: { [key: string]: any } = {}

  constructor(vibratoClient: any) {
    this.client = vibratoClient
  }

  async init() {
    const tasks = await this.client.getTasks()
    this.allTasks = tasks
    this.allTasks.forEach((task) => {
      this.tasks[task.slug] = {
        task: task,
        slug: task.slug,
        service: new TaskService(task)
      }
    })
  }

  getTask(slug: string): Task {
    return this.tasks[slug].task
  }

  getTaskSlugs(): string[] {
    return Object.keys(this.tasks)
  }

  async getRecipientType(slug: string): Promise<RecipientType> {
    if (this.recipientTypes[slug]) {
      return this.recipientTypes[slug]
    }

    const rt = await this.client.getRecipientType(slug)
    this.recipientTypes[slug] = rt

    return rt
  }
}

export class DynamicTaskService {
  task: any

  constructor(task: DynamicTask) {
    this.task = task
  }

  getTask(): Task {
    return this.task
  }

  getParams(): Param[] {
    return this.task?.task_parameters
  }
}
